import React from 'react';
import {
  Grid2 as Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
} from '@mui/material';
import { WButton } from '@wareclouds/wareclouds-ui';
import { useTranslation } from 'react-i18next';
import {
  RECIPIENT_RELATIONSHIP_OPTIONS,
  RECIPIENT_DOCUMENT_MAX_LENGTH,
  VALID_RECIPIENT_DOCUMENT_REGEX_PATTERN,
} from '../../../config/consts/orders';

const fieldStyles = {
  '& .MuiOutlinedInput-root': {
    borderRadius: '4px',
    '& fieldset': {
      borderColor: 'rgba(0, 0, 0, 0.23)',
    },
  },
  '& .MuiInputLabel-root': {
    color: 'rgba(0, 0, 0, 0.6)',
  },
};

const FIELD_COMPONENTS_MAP = {
  recipientDocument: ({ t, values, handlers }) => (
    <Grid size={12} key="recipientDocument">
      <TextField
        label={t('orders.deliver.recipient_document', {
          ns: 'description',
        })}
        placeholder={t('orders.deliver.recipient_document_placeholder', {
          ns: 'description',
          defaultValue: 'Digite o documento ou RG',
        })}
        value={values.recipientDocument}
        onChange={handlers.onRecipientDocumentChange}
        fullWidth
        variant="outlined"
        inputProps={{ maxLength: RECIPIENT_DOCUMENT_MAX_LENGTH }}
        error={
          (values.recipientDocument || '').length >=
            RECIPIENT_DOCUMENT_MAX_LENGTH ||
          (values.recipientDocument &&
            !VALID_RECIPIENT_DOCUMENT_REGEX_PATTERN.test(
              values.recipientDocument
            ))
        }
        helperText={
          values.recipientDocument &&
          !VALID_RECIPIENT_DOCUMENT_REGEX_PATTERN.test(values.recipientDocument)
            ? t('validation.invalid_document', {
                ns: 'validation',
                defaultValue: 'Formato de documento inválido',
              })
            : ''
        }
        InputLabelProps={{ shrink: true }}
        sx={fieldStyles}
      />
    </Grid>
  ),

  recipientRelationship: ({ t, values, handlers }) => (
    <Grid size={12} key="recipientRelationship">
      <FormControl fullWidth sx={fieldStyles}>
        <InputLabel id="recipient-relationship-label" shrink>
          {t('orders.deliver.recipient_relationship', {
            ns: 'description',
          })}
        </InputLabel>
        <Select
          labelId="recipient-relationship-label"
          value={values.recipientRelationship}
          onChange={handlers.onRecipientRelationshipChange}
          label={t('orders.deliver.recipient_relationship', {
            ns: 'description',
          })}
          displayEmpty
          notched
          sx={{
            '& .MuiSelect-select': {
              color: values.recipientRelationship
                ? 'rgba(0, 0, 0, 0.87)'
                : 'rgba(0, 0, 0, 0.6)',
              fontWeight: values.recipientRelationship ? 'normal' : 'normal',
            },
          }}
          MenuProps={{
            PaperProps: {
              style: {
                maxHeight: 192,
                overflowY: 'scroll',
              },
            },
          }}
        >
          <MenuItem
            value=""
            sx={{
              color: 'rgba(0, 0, 0, 0.6)',
              fontStyle: 'normal',
              fontWeight: 'normal',
            }}
          >
            {t('orders.deliver.recipient_relationship_placeholder', {
              ns: 'description',
              defaultValue: 'Selecione o parentesco',
            })}
          </MenuItem>
          {RECIPIENT_RELATIONSHIP_OPTIONS.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {t(
                `orders.deliver.recipient_relationship_options.${option.key}`,
                {
                  ns: 'description',
                }
              )}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Grid>
  ),

  signature: ({ t, values, handlers }) => (
    <Grid size={12} key="signature">
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          width: '100%',
        }}
      >
        <WButton
          label={
            values.signatureData
              ? t('orders.deliver.signature.edit_signature', {
                  ns: 'description',
                }) || 'Editar firma'
              : t('orders.deliver.signature.add_signature', {
                  ns: 'description',
                })
          }
          variant="contained"
          onClick={handlers.onOpenSignatureModal}
          fullWidth
        />
      </Box>
    </Grid>
  ),
};

const DynamicRecipientFields = ({ config, values, handlers }) => {
  const { t } = useTranslation(['description']);
  const renderField = (fieldName) => {
    const FieldComponent = FIELD_COMPONENTS_MAP[fieldName];

    if (!FieldComponent) {
      console.warn(`Campo desconocido: ${fieldName}`);
      return null;
    }

    return FieldComponent({
      t,
      values,
      handlers,
    });
  };

  return <>{config.fields.map((fieldName) => renderField(fieldName))}</>;
};

export default DynamicRecipientFields;
